export interface TextureDataFrame {
    x: number,
    y: number,
    w: number,
    h: number,
}

export interface TextureDataMeta {
    format: string,
    size: { w: number, h: number },
}

export interface TextureData {
    frames: Record<string, TextureDataFrame>,
    meta: TextureDataMeta,
}

let _loaded: Record<string, TextureData> = {};

/**
 * @return {Promise<TextureData>}
 */
export async function TextureDataLoad(uri: string): Promise<TextureData>
{
    if (uri in _loaded) {
        return _loaded[uri];
    }

    let response = await fetch(uri);
    let data = await response.json();
    let frames: Record<string, TextureDataFrame> = {};

    for (const key in data.frames) {
        frames[key] = {
            x: data.frames[key].frame.x,
            y: data.frames[key].frame.y,
            w: data.frames[key].frame.w,
            h: data.frames[key].frame.h,
        };
    }

    return _loaded[uri] = {
        frames,
        meta: {
            format: data.meta.format,
            size: {
                w: data.meta.size.w,
                h: data.meta.size.h,
            },
        },
    };
}
